import { RequestError } from '@superbet-group/web.lib.utilities';

export function getRequestError(response: any) {
    return new RequestError(new Error(response.notice || JSON.stringify(response)));
}
